//import 'core-js/features/typed-array/uint8-clamped-array';
//import './prepend.polyfill';
import CIResponsive from './ci.service';

window.CIResponsive = CIResponsive;